// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_mck","cls2":"ToolsMenu-cls2_ymJ ToolsMenu-cls1_mck"};